import request from '@/utils/request';

const PATH = '/reservation/item/client/field-type';

export const getFieldTypeList = () => request({
  url: `${PATH}/list`,
  method: 'get',
});
